import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from "@angular/core";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ParticipanteConglomerado } from "src/app/model/participante.conglomerado.model";
import Utils from "src/app/shared/fgi-utils";

@Component({
    selector: 'app-conglomerado-listagem',
    templateUrl: './conglomerado-listagem.component.html',
    styleUrls: ['./conglomerado-listagem.component.scss'],
    standalone: false
})
export class ConglomeradoListagemComponent {

  @Input() conglomerados: ParticipanteConglomerado[];
  @Input() listaConglomerado: ParticipanteConglomerado[];
  @Input() msgSemResultado: boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrarConglomerado: boolean = true;
  @Input() dataHoraResultado: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarListaConglomerado: EventEmitter<any> = new EventEmitter<any>();

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public rowHovered: number | null = null;

  constructor(){

  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'codigo' || ord.atributo == 'percentual') {
      funcao = parseFloat;
    }
    this.conglomerados = this.conglomerados.sort((a, b) => {
        if (ord.sentido == "asc") {
          return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
        }
        else {
          return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
        }
      });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  btnExportarListaConglomerado() {
    this.exportarListaConglomerado.emit(null);
  }

  hover(index: number) {
    this.rowHovered = index;
  }

  hoverClean() {
    this.rowHovered = null;
  }

}
